"use strict";

define('rs/form/formobjects/label/label.formobject.view',['rs/form/formobjects/base.formobject.view'], function (BaseFormObjectView) {
  var LabelFormObjectView = BaseFormObjectView.extend({
    templates: {
      'label.formobject': 'renderFormControls'
    },
    renderFormObjectControls: function renderFormObjectControls(templateProperties) {
      return this.renderFormControls(templateProperties);
    },
    setupFormElement: function setupFormElement() {},
    getValue: function getValue() {
      return this.$('input').val();
    }
  });
  return LabelFormObjectView;
});

